import { Modal } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import { TagForm } from "modules/TagsDashboard/components/TagModal/components";
import { useCreateTagMutation, useUpdateTagsMutation } from "modules/TagsDashboard/components/TagModal/hooks";
import "modules/TagsDashboard/components/TagModal/TagModal.scss";

import type { Tag } from "models";
import type { TagFormPayload } from "modules/TagsDashboard/components/TagModal/hooks";

type TagModalProps = {
  isOpen: boolean;
  tag: Tag | null;
  onClose: () => void;
};

const FormHelper = createFormHelper<TagFormPayload>();

const isFormInvalid = ({ name, color }: TagFormPayload) => !name.trim() || !color;

export const TagModal = ({ isOpen, tag, onClose }: TagModalProps) => {
  const { mutateAsync: createTag, isPending: isCreateTagPending } = useCreateTagMutation();
  const { mutateAsync: updateTags, isPending: isUpdateTagsPending } = useUpdateTagsMutation();

  const handleSubmit = async (payload: TagFormPayload) => {
    if (isFormInvalid(payload)) return;

    if (tag !== null) await updateTags({ tags: [payload] });
    else await createTag(payload);

    onClose();
  };

  return (
    <Modal open={isOpen} size="large" className="TagModal">
      <FormHelper.Form
        onSubmit={handleSubmit}
        defaultValues={{
          id: tag?.id ?? -1,
          name: tag?.name ?? "",
          color: tag?.color ?? "#e91e63",
          is_system: tag?.is_system ?? false,
          created_on: tag?.created_on ?? ""
        }}
      >
        <TagForm isEdit={tag !== null} isPending={isCreateTagPending || isUpdateTagsPending} onClose={onClose} />
      </FormHelper.Form>
    </Modal>
  );
};
